// src/pages/Terms/Terms.jsx
//
// ПОЛЬЗОВАТЕЛЬСКОЕ СОГЛАШЕНИЕ / ПУБЛИЧНАЯ ОФЕРТА (черновик).
//
// ⚠️ ЧЕРНОВИК. Владелец: «Юридические тексты напиши пробные сам, я потом
//    сам их исправлю». Требует проверки юристом и заполнения реквизитов.
//
// 🔴 ЧТО ЗДЕСЬ ПРИНЦИПИАЛЬНО:
//    1. Для продажи товаров дистанционно нужен ПУБЛИЧНЫЙ ДОГОВОР (оферта).
//       Ст. 437 ГК РФ + ст. 26.1 Закона «О защите прав потребителей».
//    2. Ст. 26.1 ЗоЗПП даёт покупателю право отказаться от товара в любое
//       время до передачи и в течение 7 дней после — это НЕ наша любезность,
//       а требование закона. Отсюда раздел про возврат.
//    3. Потребитель вправе отказаться от товара надлежащего качества при
//       сохранении его вида и потребительских свойств.
//    4. Момент заключения договора — подтверждение заказа оператором,
//       а не отправка формы клиентом. Это важно для споров.
import React from 'react';
import {
  LegalPage,
  LegalSection,
  LegalList,
} from '../../components/common/LegalPage/LegalPage.jsx';
import { REQUISITES, REQUISITES_ADDRESS } from '../../utils/requisites.js';

export const Terms = () => (
  <LegalPage
    // 🔴 ЗАГОЛОВОК ПРИВЕДЁН В СООТВЕТСТВИЕ С СОДЕРЖАНИЕМ (2026-10-07).
    //    Документ САМ СЕБЯ называет публичной офертой (см. `intro`), но был
    //    озаглавлен «Пользовательское соглашение» — это разные вещи по
    //    ГК РФ (ст. 435-438). Покупатель, ища оферту, не находил её по
    //    названию, а юридически неверный заголовок ослабляет позицию.
    //    Для интернет-магазина оферта ОБЯЗАТЕЛЬНА (ст. 26.1 ЗоЗПП).
    title="Публичная оферта (пользовательское соглашение)"
    intro="Настоящий документ является публичной офертой (предложением) о заключении договора купли-продажи товаров дистанционным способом и определяет условия использования сайта рекламного агентства «Студия Рекламы»."
  >
    <LegalSection number="1" title="Общие положения">
      <p>
        1.1. Настоящее Соглашение регулирует отношения между{' '}
        {REQUISITES.legalName} (далее — Продавец) и любым лицом (далее —
        Покупатель), использующим сайт {REQUISITES.siteUrl} и оформляющим
        заказ.
      </p>
      <p>
        1.2. Оформление заказа на сайте означает акцепт настоящей оферты в
        соответствии со статьёй 438 Гражданского кодекса Российской
        Федерации.
      </p>
      <p>
        1.3. Продавец: {REQUISITES.legalName}, ИНН {REQUISITES.inn},
        ОГРНИП {REQUISITES.ogrnip}, адрес: {REQUISITES_ADDRESS},
        телефон: {REQUISITES.phone}, email: {REQUISITES.email}.
      </p>
    </LegalSection>

    <LegalSection number="2" title="Предмет договора">
      <p>
        2.1. Продавец обязуется передать Покупателю товар, а Покупатель
        обязуется принять и оплатить товар на условиях настоящего Соглашения.
      </p>
      <p>
        2.2. Наименование, характеристики, комплектация и цена товара
        определяются на основании сведений, размещённых на сайте, и
        указываются в счёте и (или) документах о передаче товара.
      </p>
      <p>
        2.3. Товары, представленные на сайте, могут изготавливаться на заказ и
        иметь индивидуально-определённые характеристики. Условия и сроки
        изготовления согласуются сторонами дополнительно.
      </p>
    </LegalSection>

    <LegalSection number="3" title="Оформление заказа">
      <p>
        3.1. Покупатель оформляет заказ через формы на сайте, указывая
        достоверные сведения о себе и адресе доставки.
      </p>
      <p>
        3.2. Заказ считается оформленным с момента нажатия Покупателем
        соответствующей кнопки подтверждения на сайте.
      </p>
      <p>
        3.3. Договор считается заключённым с момента направления Продавцом
        Покупателю подтверждения заказа (по электронной почте или иным
        согласованным способом). До этого момента Продавец вправе отказать в
        исполнении заказа, уведомив Покупателя.
      </p>
      <p>
        3.4. Продавец вправе запросить у Покупателя дополнительные сведения,
        необходимые для исполнения заказа.
      </p>
    </LegalSection>

    <LegalSection number="4" title="Цена и порядок оплаты">
      <p>
        4.1. Цена товара указывается в рублях Российской Федерации и включает
        налог на добавленную стоимость, если Продавец является плательщиком
        НДС.
      </p>
      <p>
        4.2. Стоимость доставки определяется отдельно и указывается при
        оформлении заказа.
      </p>
      <p>
        4.3. Окончательная стоимость товаров, изготовленных по индивидуальному
        заказу, может определяться после согласования технических параметров
        и согласуется с Покупателем до начала изготовления.
      </p>
      <p>
        4.4. Изменение Продавцом цены на уже подтверждённый заказ не
        допускается.
      </p>
      <p>
        4.5. Способы оплаты определяются при оформлении заказа. Приём платежей
        может осуществляться через платёжные сервисы третьих лиц; в этом
        случае обработка платёжных данных выполняется такими сервисами.
      </p>
    </LegalSection>

    <LegalSection number="5" title="Доставка и передача товара">
      <p>
        5.1. Способы, сроки и стоимость доставки указываются при оформлении
        заказа либо согласуются сторонами дополнительно.
      </p>
      <p>
        5.2. Право собственности на товар переходит к Покупателю с момента
        передачи товара Покупателю или указанному им лицу.
      </p>
      <p>
        5.3. Риск случайной гибели или повреждения товара переходит к
        Покупателю с момента передачи товара, если иное не предусмотрено
        законодательством.
      </p>
      <p>
        5.4. Сроки изготовления товаров по индивидуальному заказу согласуются
        сторонами; Продавец сообщает ориентировочный срок при подтверждении
        заказа.
      </p>
    </LegalSection>

    <LegalSection number="6" title="Возврат товара и отказ от договора">
      <p>
        6.1. Покупатель вправе отказаться от товара в любое время до его
        передачи, а после передачи — в течение семи дней, в соответствии со
        статьёй 26.1 Закона Российской Федерации от 07.02.1992 № 2300-1
        «О защите прав потребителей».
      </p>
      <p>
        6.2. Отказ от товара надлежащего качества возможен при условии
        сохранения его товарного вида, потребительских свойств, а также
        документа, подтверждающего факт и условия покупки.
      </p>
      <p>
        6.3. При отказе Покупателя от товара Продавец возвращает уплаченную
        сумму, за исключением расходов Продавца на доставку от Покупателя,
        не позднее чем через десять дней со дня предъявления требования.
      </p>
      <p>
        6.4. Товары, изготовленные по индивидуально-определённым
        характеристикам Покупателя, возврату и обмену не подлежат, если они
        изготовлены надлежащим образом и соответствуют согласованным
        параметрам. Условия согласуются сторонами до начала изготовления.
      </p>
      <p>
        6.5. Подробные условия возврата изложены на странице «Возврат
        товара».
      </p>
    </LegalSection>

    <LegalSection number="7" title="Права и обязанности сторон">
      <p>7.1. Продавец обязуется:</p>
      <LegalList
        items={[
          'исполнять заказы на условиях настоящего Соглашения;',
          'предоставлять Покупателю достоверную информацию о товарах;',
          'обеспевать конфиденциальность персональных данных Покупателя в соответствии с Политикой обработки персональных данных.',
        ]}
      />
      <p>7.2. Покупатель обязуется:</p>
      <LegalList
        items={[
          'предоставлять достоверные сведения при оформлении заказа;',
          'своевременно оплачивать и принимать заказанный товар;',
          'соблюдать условия настоящего Соглашения.',
        ]}
      />
    </LegalSection>

    <LegalSection number="8" title="Ответственность сторон">
      <p>
        8.1. Стороны несут ответственность в соответствии с законодательством
        Российской Федерации.
      </p>
      <p>
        8.2. Продавец не несёт ответственности за ненадлежащее использование
        товара Покупателем, а также за последствия, возникшие в результате
        предоставления Покупателем недостоверных сведений.
      </p>
      <p>
        8.3. Продавец не несёт ответственности за временную неработоспособность
        сайта, вызванную техническими причинами, и обязуется принимать
        разумные меры для её устранения.
      </p>
    </LegalSection>

    <LegalSection number="9" title="Персональные данные">
      <p>
        9.1. Оформляя заказ, Покупатель подтверждает согласие на обработку
        своих персональных данных на условиях, изложенных в Политике
        обработки персональных данных.
      </p>
      <p>
        9.2. Согласие на получение рекламных и информационных сообщений
        даётся Покупателем отдельно и не является обязательным условием
        оформления заказа.
      </p>
    </LegalSection>

    <LegalSection number="10" title="Разрешение споров и заключительные положения">
      <p>
        10.1. Споры разрешаются путём переговоров, а при недостижении
        согласия — в порядке, установленном законодательством Российской
        Федерации.
      </p>
      <p>
        10.2. Продавец вправе вносить изменения в настоящее Соглашение.
        Изменения не распространяются на заказы, подтверждённые до их
        вступления в силу.
      </p>
      <p>
        10.3. Действующая редакция: версия 1.0. Актуальный текст постоянно
        доступен по адресу {REQUISITES.siteUrl}/terms.
      </p>
    </LegalSection>
  </LegalPage>
);
